export default function RVCV({
  canvasDimension,
  finalDOMObj,
  animationFinalObjToString,
  layerLink,
  completeObj,
  typeDiff,
  savedCustomFontList,
  backupFallback,
}) {
  const fontFaceCss = savedCustomFontList
  .filter((font) => !font.isDuplicateFont)
  .map(
    (font) => `
@font-face {
  font-family: '${font.familyName}';
  src: url('${font.dataUrl}') format('${font.format}');
}`
  )
  .join("\n");

  const backupFileName = (url) => {
    const extension = new URL(url).pathname.split(".").pop();

    return `backup.${extension}`;
   }
  
  return `
<html>

<head>
    <meta charset="utf-8">
    ${layerLink}
    <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
    <meta name="format-detection" content="telephone=no" />
    <meta http-equiv="X-UA-Compatible" content="IE=Edge" />
    <meta name="ad.size" content="width=${canvasDimension?.width},height=${canvasDimension?.height}" />
    <link href="https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@400;700&display=swap" rel="stylesheet">
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.4.0/css/font-awesome.min.css">

    <script src="https://s0.2mdn.net/ads/studio/Enabler.js"></script>
    <script type="text/javascript" src="https://code.jquery.com/jquery-latest.js"></script>
    <script type="text/javascript" src="https://cdnjs.cloudflare.com/ajax/libs/gsap/1.20.3/TweenMax.min.js"></script>
    <script type="text/javascript" src="https://baijs.com/tinyscrollbar/js/jquery.tinyscrollbar.js"></script>
    <script src="https://cdnjs.cloudflare.com/ajax/libs/gsap/3.2.4/gsap.min.js"></script>
    <script src="https://cdnjs.cloudflare.com/ajax/libs/gsap/1.10.2/plugins/CSSPlugin.min.js"></script>
    
    <style>
        * {
            -moz-box-sizing: border-box;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
        }

        body {
            padding: 0;
            margin: 0;
        }

        ${finalDOMObj.CssCollect}

        #canvas-page {
            display: block !important;
        }

        .customScrollBar {
            padding-bottom: 50px;
        }

        .customScrollBar::-webkit-scrollbar {
            background-color: #fff;
        }

        p {
            margin: 0 0 0px !important;
        }

        .customScrollBar::-webkit-scrollbar {
            width: 6px;
            height: 6px;
        }

        .customScrollBar::-webkit-scrollbar-thumb {
            border-radius: 5px;
            box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
            -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
            background: rgba(0, 0, 0, 0.2);
        }

        .custonScrollBar::-webkit-scrollbar {
            background-color: #fff;
        }

        .disable .thumb {
            display: none;
        }

        ${fontFaceCss}
    </style>
</head>

<body class="customScrollBar">
    ${
    backupFallback?.s3Url
    ? `<noscript><img src="${backupFileName(backupFallback.s3Url)}" alt="Backup image fallback"></noscript>`
    : ""
    }
    ${typeDiff}
    <script>
        var arrObject = ${animationFinalObjToString}

        var fps = 60
        var tempGpsa = [];
        var count = 0;
        var clearTimer = [];
        var MaxDuration = [];
        var collectID = [];
        let collectscreenShotImages = "";
        var loopAnimation = 1
        var set = true;
        let maxIndex = -1;
        let totalDuration = 0;
        let completeObj = ${completeObj};

        function scrollBarCheck(maxSeconds) {
            for (let i = 0; i < completeObj.length; i++) {
                scrollBarScreenShot(completeObj[i].id, maxSeconds);
            }
        }
        function enableTxt(item) {
            event.stopPropagation();
            event.preventDefault();
            // Component-specific link (e.g. text inside scrollbar) must win over global.
            var urltest = $(item).data("url");
            if (urltest !== undefined && urltest !== "https://" && urltest !== "http://" && urltest !== "") {
                window.open(urltest);
                return;
            }
            var urltestGlobal = $('#canvas-page').data("global");
            var urltextGlobalCheck = $('#canvas-page').data("link");
            if (urltextGlobalCheck && urltextGlobalCheck !== "undefined" && urltestGlobal !== "https://" && urltestGlobal !== "") {
                window.open(urltestGlobal);
            }
        }

        function getElements(elem) {
            let element = [];
            for (let i = 0; i < elem.length; i++) {
                element.push(document.getElementById(elem[i]));
                //console.log("in Test");
            }
            return element;
        }

        function animationRepeat(AryObj) {

            var masterTimeLine = new TimelineMax({ repeat: 0 });
            gsap.ticker.fps(fps);

            if (loopAnimation && set === true) {
                Array.prototype.max = function () {
                    return Math.max.apply(null, this);
                };
                for (let j = 0; j < AryObj.length; j++) {
                    let obj = AryObj[j];
                    MaxDuration.push((obj.duration || 0) + obj.op.delay);
                }

                const max = MaxDuration.max();
                maxIndex = MaxDuration.indexOf(max);
            }
            let i = 0;

            for (i = 0; i < AryObj.length; i++) {
                var obj = AryObj[i];
                var funcName = obj.api;
                let value = getElements(obj.atoms);
                if (value[0]) {
                    let createGPSA = gsap.timeline();
                    if (maxIndex === i && set === true) {
                        let newObj = obj.op;
                        newObj.onComplete = function () {
                            setTimeout(loopClear, 100);
                        }

                        let timeMax = createGPSA.to([value], (obj.duration || 0), newObj);
                        //	console.log(timeMax,"timeMax")
                        totalDuration = timeMax;
                        tempGpsa.push(timeMax);
                        set = false;
                    } else {

                        tempGpsa.push(createGPSA.to([value], (obj.duration || 0), obj.op));
                        MaxDuration.push(createGPSA.totalDuration())
                    }
                    //  console.log(value[0],"value0000")
                    collectID.push("#" + obj.atoms)
                }
            }

            screenshot(Math.round(MaxDuration[maxIndex]));
        }

        function customScrollISIPI(id) {
            const scrollContainer = document.getElementById(id);
            if (!scrollContainer) return;

            let scrollAmount = 0;
            const scrollStep = 0.2;
            const scrollInterval = 20;
            let isUserScrolling = false;
            let interval;

            let isHovered = false;

            function autoScroll() {
                if (!isUserScrolling && !isHovered) {  // Pause scrolling when hovered
                    if (scrollAmount < scrollContainer.scrollHeight - scrollContainer.clientHeight) {
                        scrollAmount += scrollStep;
                        scrollContainer.scrollTop = scrollAmount;
                    } else {
                        scrollContainer.scrollTop = 0;
                        scrollAmount = 0;
                        clearInterval(interval);
                    }
                }
            }

            interval = setInterval(autoScroll, scrollInterval);

            scrollContainer.addEventListener('scroll', function () {
                isUserScrolling = true;
                scrollAmount = scrollContainer.scrollTop;
                clearInterval(interval);

                if (scrollContainer.scrollTop !== 0) {
                    clearTimeout(scrollContainer.scrollTimeout);
                    scrollContainer.scrollTimeout = setTimeout(function () {
                        isUserScrolling = false;
                        interval = setInterval(autoScroll, scrollInterval);
                    }, 0);
                }
            });

            scrollContainer.addEventListener('mouseenter', function () {
                isHovered = true;
            });

            scrollContainer.addEventListener('mouseleave', function () {
                isHovered = false;
            });
        }
        function loopClear() {

        }


        //  async function screenshot(maxSeconds) {
        //       const numScreenshots = Math.floor(maxSeconds);                
        //       for (let i = 0; i <= numScreenshots; i++) {  

        //           await new Promise(resolve => setTimeout(resolve, i * 1000));

        //           gsap.globalTimeline.play();
        //           await new Promise(resolve => setTimeout(resolve, 0));
        //           await takeshot(); 
        //           gsap.globalTimeline.pause();
        //           if (completeObj.length > 0) {
        //               scrollBarCheck();
        //           } else if (i === numScreenshots) {
        //               await new Promise(resolve => setTimeout(resolve, 10));
        //               window.status = "ready";
        //           }
        //       }
        //   }


        let intervalId;

        async function screenshot(maxSeconds) {
            const numScreenshots = Math.floor(maxSeconds) + 1;
            await takeshot();
            gsap.globalTimeline.play();
            if (intervalId) {
                clearInterval(intervalId);
            }
            let count = 1;
            intervalId = setInterval(async () => {

                await takeshot();
                // if (completeObj.length > 0) {
                //     scrollBarCheck(maxSeconds);
                // }
                count++;

                if (count >= numScreenshots) {
                    clearInterval(intervalId);
                    window.status = "ready";
                }
            }, 1000);

            setTimeout(() => {
                clearInterval(intervalId);
            }, (maxSeconds + 1) * 1000);
        }


        async function takeshot() {
            await window.md5();

        }


        async function scrollBarScreenShot(id) {
            let currContentTop = 0;
            let tinyscrollbar = $("#" + id + "ISIInfo")
            let fooVis = $("#" + id + "viewport").height();
            let overViewHeight = $("#" + id + "overview").height();
            let heightOfOverview = $("#" + id + "overview").height() - fooVis;
            await takeshot()
            if (heightOfOverview > fooVis) {
                let topvalue = currContentTop + fooVis;
                for (topvalue; topvalue < heightOfOverview;) {

                    tinyscrollbar.data().plugin_tinyscrollbar.update(topvalue);
                    await new Promise(resolve => setTimeout(resolve, 100));
                    topvalue = topvalue + fooVis;
                    await takeshot();
                }
                topvalue = topvalue - fooVis;
                if ((topvalue) < overViewHeight) {

                    let remainingTopvalue = (overViewHeight - topvalue - fooVis);
                    topvalue = topvalue + remainingTopvalue;
                    tinyscrollbar.data().plugin_tinyscrollbar.update(topvalue);
                    await new Promise(resolve => setTimeout(resolve, 10));
                    await takeshot();
                }

            }
            else {
                let remainingTopvalue = (overViewHeight - fooVis);
                tinyscrollbar.data().plugin_tinyscrollbar.update(remainingTopvalue);
                await new Promise(resolve => setTimeout(resolve, 50));
                await takeshot();
            }
            window.status = "ready"
        }



        function stopAndStart(id) {
            clearInterval(clearTimer[id]);

            setTimeout(function () {
                let tinyscrollbar = $("#" + id + "ISIInfo").data("plugin_tinyscrollbar");

                tinyscrollbar.update(0);
            }, 1000);
        }

        function ControlThumb(id) {
            var scrollThumbCurrPos = 0;
            var scrollThumbMaxPos = 119; // top position value of thumb div when collapse
            var scrollThumbMinPos = 0;
            let scrollTrackHeight = 0;
            $("#" + id + "thumb", "#" + id + "track", "#" + id + "viewport", "#" + id + "overview").bind("click", function () {
                clearInterval(clearTimer[id]);
            });

            if (
                $("#" + id + "overview").position().top <= parseInt($("#" + id + "viewport").height()) - parseInt($("#" + id + "overview").height())
            ) {
                stopAndStart(id);
                $("#" + id + "scrollbar").addClass(id + "activeScroller");
            } else {
                scrollTrackHeight = $("#" + id + "track").height();
                $("#" + id + "scrollbar").addClass(id + "activeScroller");
                scrollThumbCurrPos = parseFloat($("#" + id + "thumb").css("top")); //$("#thumb").position().top;
                var maxOverviewTop =
                    $("#" + id + "overview").height() - $("#" + id + "viewport").height() + 0; //  top position value of overview div when full scroll down by mousewheel or drag but not clicking bottomArrow
                if (scrollTrackHeight > 100) {
                    scrollThumbMaxPos = 208.5; // top position value of thumb div when expand
                } else {
                    scrollThumbMaxPos = 50; // top position value of thumb div when collapse
                }
                scrollThumbCurrPos = scrollThumbCurrPos - 5;
                scrollThumbCurrPos = Math.min(scrollThumbCurrPos, scrollThumbMaxPos);
                if (scrollThumbCurrPos < scrollThumbMaxPos) {
                    var currContentTop = Math.floor($("#" + id + "overview").position().top);

                    if (currContentTop <= 0) {
                        currContentTop = currContentTop - 1;

                        currContentTop = currContentTop * -1;
                    }

                    currContentTop = Math.min(currContentTop, maxOverviewTop);

                    let tinyscrollbar = $("#" + id + "ISIInfo").data("plugin_tinyscrollbar");

                    tinyscrollbar.update(currContentTop);
                }
            }
        }
        function scrollTrap(id) {
            $("#" + id + 'ISIInfo').tinyscrollbar();
            var scrollTrackHeight = $("#" + id + 'track').height();
            var scrollThumbCurrPos = 0;
            var scrollThumbMaxPos = 119; // top position value of thumb div when collapse
            var scrollThumbMinPos = 0;

            $("#" + id + "arrowBottom").bind("click", function () {
                scrollTrackHeight = $("#" + id + "track").height();

                scrollThumbCurrPos = parseFloat($("#" + id + "thumb").css("top")); //$("#thumb").position().top;
                var maxOverviewTop =
                    $("#" + id + "overview").height() - $("#" + id + "viewport").height() + 0; //  top position value of overview div when full scroll down by mousewheel or drag but not clicking bottomArrow
                if (scrollTrackHeight > 97) {
                    scrollThumbMaxPos = 533; // top position value of thumb div when expand
                } else {
                    scrollThumbMaxPos = 45; // top position value of thumb div when collapse
                }
                scrollThumbCurrPos = scrollThumbCurrPos + 5;
                scrollThumbCurrPos = Math.min(scrollThumbCurrPos, scrollThumbMaxPos);
                //if(scrollThumbCurrPos<=scrollThumbMaxPos){
                var currContentTop = $("#" + id + "overview").position().top;
                if (currContentTop <= 0) {
                    currContentTop = currContentTop - 10;
                    currContentTop = currContentTop * -1;
                }
                currContentTop = Math.min(currContentTop, maxOverviewTop);
                if (currContentTop < 4635) {
                    var scroll = $("#" + id + "ISIInfo").tinyscrollbar();

                    $(scroll).data().plugin_tinyscrollbar.update(currContentTop);
                    //  $("#ISIInfo").tinyscrollbar_update(currContentTop);
                }
                //}
            });
            var scrollInterval = null;
            $("#" + id + "arrowBottom", "#" + id + "arrowTop").bind("mousedown", function (e) {
                if ($(e.target).hasClass("bottom_arrow"))
                    scrollInterval = setInterval(function () {
                        $(".bottom_arrow").trigger("click");
                    }, 100);
                else
                    scrollInterval = setInterval(function () {
                        $(".top_arrow").trigger("click");
                    }, 100);
            });

            $("#" + id + "arrowBottom", "#" + id + "arrowTop").bind("mouseup mousemove", function (e) {
                clearInterval(scrollInterval);
            });
            $("#" + id + "arrowTop").bind("click", function () {
                scrollTrackHeight = $("#" + id + "track").height();
                scrollThumbCurrPos = $("#" + id + "thumb").position().top;
                scrollThumbCurrPos = scrollThumbCurrPos - 5;
                if (
                    scrollThumbCurrPos < scrollThumbMinPos &&
                    $("#" + id + "thumb").position().top >= scrollThumbMinPos
                )
                    scrollThumbCurrPos = $("#" + id + "thumb").position().top;
                if (scrollThumbCurrPos >= scrollThumbMinPos) {
                    var currContentTop = $("#" + id + "overview").position().top;

                    if (currContentTop < 0) {
                        currContentTop = currContentTop + 10;
                        currContentTop = currContentTop * -1;
                        currContentTop = Math.max(currContentTop, 0);
                    } else currContentTop = 0;
                    //console.log(currContentTop);
                    var scroll = $("#" + id + 'ISIInfo').tinyscrollbar();

                    $(scroll).data().plugin_tinyscrollbar.update(currContentTop);
                    // $("#ISIInfo").tinyscrollbar_update(currContentTop);
                }
            });
        }
        async function pageLoadedHandler() {
            if (arrObject.length) {

                animationRepeat(arrObject);
            } else {
                await takeshot();
                await new Promise(resolve => setTimeout(resolve, 1000));
                window.status = "ready"
            }
        }

        window.onload = function () {
            if (Enabler.isPageLoaded()) {
                pageLoadedHandler();
            } else {
                Enabler.addEventListener(
                    studio.events.StudioEvent.PAGE_LOADED,
                    pageLoadedHandler
                );
            }
        };


        for (let i = 0; i < completeObj.length; i++) {
            $("#" + completeObj[i].id + 'ISIInfo').tinyscrollbar({ trackSize: completeObj[i].trackHeight, thumbSize: completeObj[i].thumbHeight, thumbSizeMin: 2 });
        }

    </script>
</body>

</html>`;

}